export default __webpack_public_path__ + "static/media/Vasanth Shetty.d7b5bfc1.jpg";